import React, { useEffect, useState, useRef, forwardRef, useMemo } from "react";
import JoditEditor from "jodit-react";

const RichTextBoxEditer = forwardRef(
  (
    props: {
      readOnly: boolean;
      editorContent: string;
      onChange: (val: any) => void;
    },
    ref
  ) => {
    const editorRef = useRef(null);
    const [content, setContent] = useState<string>("");
    const [isEditorContent, setIsEditorContent] = useState<boolean>(false);

    const config = {
      height: 400,
      readonly: props.readOnly,
      toolbarAdaptive: false,
      showCharsCounter: false,
      showWordsCounter: false,
      allowResizeX: false,
      buttons: props.readOnly
        ? ["fullsize"]
        : [
            "bold",
            "italic",
            "underline",
            "strikethrough",
            "|",
            "superscript",
            "subscript",
            "|",
            "ul",
            "ol",
            "|",
            "outdent",
            "indent",
            "align",
            "|",
            "font",
            "fontsize",
            "brush",
            "paragraph",
            "|",
            {
              name: "checkbox",
              tooltip: "Insert Checkbox",
              iconURL:
                "https://img.icons8.com/material-outlined/24/000000/checked-checkbox.png",
              exec: function (editor: any) {
                // Generate a unique ID for the checkbox
                const checkboxId = `checkbox-${Date.now()}`;

                // HTML for the checkbox
                const checkboxHtml = `
                 <input type="checkbox" id="${checkboxId}"  
                 onchange="if(this.checked) {
                   this.setAttribute('checked', 'true');
                   this.setAttribute('data-checked', 'true');
                 } else {  
                   this.removeAttribute('checked');
                   this.removeAttribute('data-checked');
                 }">
               `;

                // Insert the HTML into the editor
                editor.selection.insertHTML(checkboxHtml);
              },
            },
            {
              name: "datePicker",
              tooltip: "Insert Date",
              iconURL:
                "https://img.icons8.com/material-outlined/24/000000/calendar.png",
              popup: (editor: any, current: any, self: any, close: any) => {
                function onSelected(e: any) {
                  const dateField = e.target.value;
                  if (dateField) {
                    const date = new Date(dateField)
                      .toLocaleDateString()
                      .padStart(10, "0");
                    console.log("dateField", date, editor.selection);
                    editor.selection.insertHTML(date + "");
                  }
                }
                const divElement = editor.create.div("date-field-popup");
                const dateElement = document.createElement("input");
                dateElement.setAttribute("type", "date");
                divElement.appendChild(dateElement);
                dateElement.onchange = onSelected;
                // console.log("divElement", divElement);
                return divElement;
              },
            },
            "table",
            "|",
            "image",
            "link",
            "|",
            "hr",
            "eraser",
            "|",
            "undo",
            "redo",
            "|",
            "fullsize",
          ],
    };

    const handleUpdate = (newContent: any) => {
      console.log("newContent", newContent, ref);
      if (newContent !== undefined) {
        let changedData = newContent;
        const cleanedContent = newContent
          .replace(/<p>\s*<br\s*\/?>\s*<\/p>/g, "")
          .trim();
        if (cleanedContent === "") {
          changedData = "";
        }
        props.onChange(changedData);
      }
    };

    useEffect(() => {
      if (
        props.editorContent !== content &&
        (props.readOnly || !isEditorContent)
      ) {
        setContent(props.editorContent);
        setIsEditorContent(true);
      }
    }, [props.editorContent]);

    return useMemo(
      () => (
        <div key="editor">
          <JoditEditor
            ref={ref || editorRef}
            id="editor"
            value={content}
            config={config}
            onChange={handleUpdate}
          />
        </div>
      ),
      [content]
    );
  }
);

export default RichTextBoxEditer;
